export default "__VITE_ASSET__DXG_Z_c8__"